import StickyBlocks from "./sticky-blocks";

class StickyInner extends StickyBlocks {
    panels = Array.from(document.querySelectorAll('.sticky-block'));
    addHeight = -150;
    isObservePage = true;

    constructor() {
        super();
        const _this = this;
        let firstScroll = true;

        if (this.isObservePage)
            this.startObservePage();

        document.addEventListener('click', function () {
            setTimeout(function () {
                _this.setTop();
            }, 1000);
        });

        window.addEventListener('scroll', function() {
            if (firstScroll) {
                _this.setTop();
                firstScroll = false;
            }
        });
    }

    setTop() {
        this.panels.forEach((item:HTMLElement) => {
            let {height} = item.getBoundingClientRect();
            let top = (document.documentElement.clientHeight) - height + this.addHeight;

            item.style.top = ((top < 0) ? top : this.getTop()) + 'px';
        });
    }

    startObservePage() {
        const containerPage = document.querySelector('.page.sticky-block');
        const observer = new MutationObserver(mutationRecords => {
            this.setTop();
        });

        observer.observe(containerPage, {
            attributes: false,
            childList: true,
            subtree: true,
            characterData: true
        });
    }
}

export default StickyInner;
